import { Badge } from "@/components/ui/badge";
import { useI18n } from "@/i18n/I18nProvider";
import { CheckCircle, AlertTriangle, XCircle } from "lucide-react";

export default function StatusBadge({ status }) {
  const { t } = useI18n();

  const config = {
    valid: {
      label: t("status.valid"),
      className: "bg-emerald-100 text-emerald-700 border-emerald-200 hover:bg-emerald-100",
      icon: CheckCircle
    },
    warning: {
      label: t("status.warning"),
      className: "bg-amber-100 text-amber-700 border-amber-200 hover:bg-amber-100",
      icon: AlertTriangle
    },
    expired: {
      label: t("status.expired"),
      className: "bg-red-100 text-red-700 border-red-200 hover:bg-red-100",
      icon: XCircle
    }
  };

  const { label, className, icon: Icon } = config[status] || config.valid;

  return (
    <Badge variant="outline" className={`status-badge ${className}`}>
      <Icon className="h-3 w-3 mr-1" />
      {label}
    </Badge>
  );
}
